export default "__VITE_ASSET__CDW9gUAt__"